import React from "react";
import { useLoadingContext } from "states/loadingContext";
import { square } from "ldrs";
square.register();

const LoadingOverlay = () => {
    const { isLoading } = useLoadingContext();
    if (!isLoading) return null;
    return (
        <div
            style={{
                position: "fixed",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                backgroundColor: "rgba(0, 0, 0, 0.5)",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                zIndex: 99999999999,
                color: "white",
                fontSize: "24px",
            }}
        >
            <div>
                <l-square
                    size="40"
                    stroke="3.5"
                    speed="1"
                    color="white"
                ></l-square>
            </div>
        </div>
    );
};

export default LoadingOverlay;
